import Lock from "../Lock";

export const SQHeaderLockContent = [
  {
    title: Lock,
    showImage: false,
    sortable: false,
    key: "88-88",
    classList: ["dummyLockToolTip"],
    tooltip: {
      title: "Only available to ShotQuality Subscribers",
      text: "Available to existing ShotQuality Bets members. New memberships are no longer available.",
      link: "/login",
    },
  },
];

const SQPremiumLock = [
  {
    title: Lock,
    showImage: false,
    sortable: false,
    key: "88-88",
    classList: ["dummyLockToolTip"],
    tooltip: {
      title: "Only available to ShotQuality premium",
      text: "Available to existing ShotQuality Premium members. Plan upgrades are no longer available.",
      link: "/login",
    },
  },
];
export default SQPremiumLock;
